var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.currentUser)?_c('div',{staticClass:"mb-4"},[_c('CustomerMemoTable',{ref:"memoTable",on:{"view:row":term => _vm.$refs.memoView.viewMemo(term)}}),_c('CustomerMemoView',{ref:"memoView"})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }